module.exports = __webpack_public_path__ + "static/media/slide-rafa.07386c31.png";